<template>
  <div>
 <!-- Breadcrumb Section Begin -->
 <div class="breacrumb-section">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-text">
                      <router-link to="/"><i class="fa fa-home"></i> {{ $t('nav.home') }}</router-link>
                        <span>{{ $t('breadcrumb.about') }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Breadcrumb Section Begin -->

    <div class="container text-center" v-if="sobre!=''">
        <div class="row">
          <div class="col-lg-6"><br><br><br>
            <img v-if="sobre[0].insInstitucionalImagens!=''" :src="$imgURL + sobre[0].insInstitucionalImagens[0].itgUrlImagem" class="img-fluid" alt="...">
          </div>
          <div class="col-lg-6">
            <h2 class="titulo-sobre-01">{{ $localeField(sobre[0], 'itiNome') }}</h2>
            <p class="txt-left" v-html="$localeHtml(sobre[0], 'itiResumo1')"></p><br>
          </div>
        </div>
    </div>
    <!-- final sobre 1 -->

    <!-- missão e nossa equipe -->
    <section class="missao" v-if="itenssobre!=''">
        <div class="container text-center">
            <div class="row">
              <div class="col-lg-6" v-for="itsob in itenssobre" :key="itsob.itiId">
                <h4 class="titulo-sobre-03">{{ $localeField(itsob, 'itiReferencia') }}</h4>
                <h2 class="titulo-sobre-02">{{ $localeField(itsob, 'itiNome') }}</h2>
                <p class="txt-left" v-html="$localeHtml(itsob, 'itiResumo1')"></p>
              </div>
            </div>
        </div>
    </section>
    <!-- missão e nossa equipe final -->

    <!-- accordion -->
    <div class="faq-section spad" v-if="duvidas!=''">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">              
                  <div class="faq-accordion">
                      <div class="accordion" id="accordionExample">
                        <div class="card" v-for="(itduv, index) in duvidas" :key="index" style="padding-bottom: 15px;">
                          <div class="card-heading" :class="{ active: isActive(index) }">
                            <a @click="toggle(index)">
                              <span class="toggle-icon iconaccor">{{ isActive(index) ? '-' : '+' }}</span>
                              {{ $localeField(itduv, 'itiNome') }}
                            </a>
                          </div>
                          <div :id="'collapse' + index" class="collapse" :class="{ show: isActive(index) }">
                            <div class="card-body">
                              <p v-html="$localeHtml(itduv, 'itiResumo1')"></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- accordion final -->
  </div>
</template>

<script>
//import moment from 'moment'
import axios from 'axios';
import VueJsCounter from 'vue-js-counter'
import { Swiper, SwiperSlide } from 'swiper/vue';
import { useHead } from '@vueuse/head';

export default {
  name: 'SobreView',
  components: {
    VueJsCounter,
    Swiper,
    SwiperSlide
  },
  data: () => ({
    sobretopo: [],
    sobre:[],
    duvidas:[],
    itenssobre:[],  
    activeIndex: null,
  }),
  methods: {
    carregaMetas() {
			useHead({
				title: 'Sobre - Sub4 Turismo'
			})
		},
    toggle(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
    isActive(index) {
      return this.activeIndex === index;
    },
  },
  created() {
    this.carregaMetas();

    axios.get('/Process/InsInstitucional/institucional/12/sobre')
      .then(response => {
        this.sobre = response.data;
      })
      .catch(error => {
        console.error(error);
      });
      
      axios.get('/Process/InsInstitucional/institucional/40/itenssobre')
      .then(response => {
        this.itenssobre = response.data.filter(x=> x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
      })
      .catch(error => {
        console.error(error);
      });

      axios.get('/Process/InsInstitucional/institucional/41/duvidas')
      .then(response => {
        this.duvidas = response.data.filter(x=> x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
      })
      .catch(error => {
        console.error(error);
      });
  },
}
</script>

<style>
.faq-accordion .card-heading {
  font-size: 22px;
    color: #252525;
    font-weight: 700;
    cursor: pointer;
}


.faq-accordion .card-body {
  padding: 10px;
}

.collapse {
  display: none;
}

.collapse.show {
  display: block;
}

.iconaccor{
  font-family: 'fontAwesome';
  float: left;
  font-size: 13px;
  color: #ffffff;
  background: #e7ab3c;
  height: 25px;
  width: 25px;
  text-align: center;
  line-height: 25px;
  margin-top: 3px;

  margin-right: 15px;
  left: 0;
  top: 0;
}
</style>
